/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

export const TITLES = {
  SAVE: "Save",
  CANCEL: "Cancel",
  ACCOUNT_NAME: "Account Name",
  ADD_ACCOUNT: "Add Account",
  EDIT_ACCOUNT: "Edit Account",
  ACCOUNT_DISPLAY_NAME: "Display Name",
  ACCOUNT_COST_CENTER: "Cost Center",
  ACCOUNT_KEY: "Account Key",
};

export const MESSAGES = {
  COST_CENTER_INVALID: "Cost Center is invalid",
  COST_CENTER_REQUIRED: "Cost Center is required",
  DISPLAY_NAME_REQUIRED: "Display Name is required",
  ACCOUNT_KEY_REQUIRED: "Account key is required",
  ACCOUNT_CREATED: "Account created successfully",
  ACCOUNT_NAME_REQUIRED: "Account Name is required",
  ACCOUNT_NAME_TOOLTIP: "Name of the Account, must be unique and cannot be changed once created, can only contain lowercase alphanumeric (a-z, 0-9) characters. Max length is 20 characters.",
  ACCOUNT_DISPLAY_NAME_TOOLTIP: "Display Name of the Account",
  ACCOUNT_COST_CENTER_TOOLTIP: `Identifier for the cost center that will be charged to process the request, based on environment type.

  For internal product development (PD) environments, use 474000.
  For internal non-PD environments, use the Cost Center ID of the group using the environment.
  For customer environments with revenue generating agreements, use 131000.
  For customer proof of concept (POC) environments (not generating income), use 206500.`,
  ACCOUNT_KEY_TOOLTIP: `This key will uniquely identify the customer and can't be changed later. Only lowercase alphabets are allowed (a-z). Max length is 8 characters.`,
  MAX_ACCOUNT_KEY_LENGTH: 'Account Key cannot exceed 8 characters.',
  ACCOUNT_KEY_ALLOWED_CHARACTERS: 'Account Key should contain only lowercase alphabets (a-z). Max length is 8 characters.',
  ACCOUNT_KEY_REGEX: /^[a-z]+$/,
  ACCOUNT_NAME_REGEX: /^[a-z0-9]+$/,
  MAX_ACCOUNT_NAME_LENGTH: 'Account Name cannot exceed 20 characters.',
  ACCOUNT_NAME_ALLOWED_CHARACTERS: 'Account Name should contain only alphanumeric characters and underscores (a-z, 0-9)',
};
